// extracted by mini-css-extract-plugin
export default {"container":"a1-z","list":"b1-z"};